import { Button, Spinner } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { CustomModalFooter } from 'src/components/custom_components/CustomModal';

import { I18NextNS } from 'src/models/Language.model';

export default function SavingFooter() {
  const { t } = useTranslation(I18NextNS.PAGES);

  return (
    <CustomModalFooter>
      <Button
        variant="primary"
        disabled
        data-track="exam.analyzing-modal.saving"
        data-observe
      >
        <Spinner size="sm" className="me-2" />
        {t('newExam.submitting')}
      </Button>
    </CustomModalFooter>
  );
}
